var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { axios } from '@ori/axios';
import axiosRetry from 'axios-retry';
import camelcaseKeys from 'camelcase-keys';
import { applyDateMiddleware } from './applyDateMiddleware';
import { customQuerySerializer } from './customQuerySerializer';
import { formatToken } from './prepareToken';
/** List of properties excluded from the naming convention transformation. */
export var excludedPropertyNames = ['__typeName'];
var AUTHORIZATION_HEADER = 'Authorization';
var LANGUAGE_HEADER = 'Accept-Language';
var TENANT_HEADER = 'x-tenant-context';
var DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var applyCaseMiddleware = function (axiosInstance, options) {
    var exclude = [];
    if (options === null || options === void 0 ? void 0 : options.exclude) {
        exclude.push.apply(exclude, options.exclude);
    }
    exclude.push.apply(exclude, excludedPropertyNames);
    axiosInstance.interceptors.response.use(function (response) { return (__assign(__assign({}, response), { data: camelcaseKeys(response.data, __assign(__assign({ deep: true }, options), { exclude: exclude })) })); });
};
var ApiClient = /** @class */ (function () {
    function ApiClient(options) {
        var baseUrl = options.baseUrl, language = options.language, tenant = options.tenant, token = options.token, camelcaseKeysOptions = options.camelcaseKeysOptions, axiosRetryOptions = options.axiosRetryOptions, httpAgent = options.httpAgent, httpsAgent = options.httpsAgent, _a = options.timeout, timeout = _a === void 0 ? DEFAULT_REQUEST_TIMEOUT_MS : _a;
        this.axiosInstance = axios.create({
            baseURL: baseUrl,
            httpAgent: httpAgent,
            httpsAgent: httpsAgent,
            // This is due to the mismatch ClientGenerator(v1) and api client(v0) axios versions.
            // It will be removed by upcoming PR.
            paramsSerializer: {
                serialize: customQuerySerializer,
            },
            timeout: timeout,
        });
        var formattedToken = formatToken(token);
        if (formattedToken) {
            this.axiosInstance.defaults.headers.common[AUTHORIZATION_HEADER] = formattedToken;
        }
        if (tenant) {
            this.axiosInstance.defaults.headers.common[TENANT_HEADER] = tenant;
        }
        if (language) {
            this.axiosInstance.defaults.headers.common[LANGUAGE_HEADER] = language;
        }
        if (typeof axiosRetryOptions !== 'undefined') {
            axiosRetry(this.axiosInstance, axiosRetryOptions);
        }
        applyDateMiddleware(this.axiosInstance);
        applyCaseMiddleware(this.axiosInstance, camelcaseKeysOptions);
    }
    ApiClient.prototype.createFetcher = function () {
        var _this = this;
        return function (config, options) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, this.axiosInstance(__assign(__assign({}, config), options))];
        }); }); };
    };
    return ApiClient;
}());
export { ApiClient };

